module.exports = __webpack_public_path__ + "img/dinkenclave-11.c7f1dac7.jpeg";